import React from "react";
import Styles from "./styles.module.scss";
import useCurrency from "../../../yoello-lib/modules/localisation/useCurrency";

interface ISelectedOptionPriceProps {
  price: string;
  count: number;
}

function SelectedOptionPrice({ price, count }: ISelectedOptionPriceProps) {
  const { formatCurrency } = useCurrency();
  const formattedPrice = formatCurrency(parseFloat(price));
  return (
    <p className={Styles.SelectionOptionPriceText}>
      {count > 1 ? `${count}x ` : ""}
      {formattedPrice}
    </p>
  );
}

export default SelectedOptionPrice;
